export function keys(object) {
    return Object.keys(object);
}
